import { yupResolver } from '@hookform/resolvers/yup';
import { Modal, Form } from 'react-bootstrap';
import { useForm } from 'react-hook-form';
import * as Yup from 'yup';
import PropTypes from 'prop-types';
import { useEffect, useState } from 'react';

import Flex from 'components/common/Flex';
import { FormProvider, RHFSelect } from 'components/common/form';
import LoadingButton from 'components/common/LoadingButton';

export const DOCUMENT_TYPES = [
  "Child's Birth Certificate",
  "Child's Death Certificate",
  "Child's Passport",
  "Child's National ID",
  "Child's Medical History",
  "Child's Doctor or Professional",
  "Child's Social Worker Documents",
  "Father's Birth Certificate",
  "Father's Death Certificate",
  "Father's Passport",
  "Father's National ID",
  "Mother's Birth Certificate",
  "Mother's Death Certificate",
  "Mother's Passport",
  "Mother's National ID",
  "Guardian's Birth Certificate",
  "Guardian's Death Certificate",
  "Guardian's Passport",
  "Guardian's National ID",
  "Guardian's Legal Authority Documents"
];

const documentTypeOptions = DOCUMENT_TYPES.map(type => ({
  label: type,
  value: type
}));

const schema = Yup.object().shape({
  documentType: Yup.string().required('Please select a document type')
});

function SupportingDocsUploadModal({ show, onHide, onSubmit, loading }) {
  const [file, setFile] = useState(null);
  const [fileError, setFileError] = useState('');

  const methods = useForm({
    mode: 'onBlur',
    reValidateMode: 'onChange',
    defaultValues: { documentType: '' },
    resolver: yupResolver(schema)
  });
  const { handleSubmit, reset } = methods;

  useEffect(() => {
    if (!show) {
      reset();
      setFile(null);
      setFileError('');
    }
  }, [show, reset]);

  const handleFileChange = e => {
    const selected = e.target.files?.[0];
    if (!selected) {
      setFile(null);
      return;
    }
    if (selected.size > 10 * 1024 * 1024) {
      setFileError('File must be 10MB or smaller');
      setFile(null);
      return;
    }
    setFileError('');
    setFile(selected);
  };

  const submit = values => {
    if (!file) {
      setFileError('Please select a file');
      return;
    }
    onSubmit({ documentType: values.documentType, file });
  };

  return (
    <Modal show={show} onHide={onHide}>
      <Modal.Header closeButton>
        <Modal.Title>Upload Supporting Document</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <FormProvider methods={methods} onSubmit={handleSubmit(submit)}>
          <Flex gap={3} direction="column" className="mt-2">
            <RHFSelect
              name="documentType"
              label="Document Type"
              placeholder="Select a document type"
              options={documentTypeOptions}
              required
              noOptional
            />

            <Form.Group>
              <Form.Label>File</Form.Label>
              <Form.Control
                type="file"
                accept=".pdf,.doc,.docx,.png,.jpg,.jpeg"
                onChange={handleFileChange}
              />
              <Form.Text className="text-muted">
                Accepted: PDF, DOC, DOCX, PNG, JPG. Max 10MB.
              </Form.Text>
              {fileError && (
                <div className="text-danger fs--1 mt-1">{fileError}</div>
              )}
            </Form.Group>

            <LoadingButton
              type="submit"
              color="primary"
              className="w-100"
              loading={loading}
            >
              Upload
            </LoadingButton>
          </Flex>
        </FormProvider>
      </Modal.Body>
    </Modal>
  );
}

SupportingDocsUploadModal.propTypes = {
  show: PropTypes.bool.isRequired,
  onHide: PropTypes.func.isRequired,
  onSubmit: PropTypes.func.isRequired,
  loading: PropTypes.bool
};

export default SupportingDocsUploadModal;
